export var ImportState;
(function (ImportState) {
    ImportState["CREATED"] = "CREATED";
    ImportState["SHEETADDED"] = "SHEETADDED";
    ImportState["IMPORTING"] = "IMPORTING";
    ImportState["IMPORTED"] = "IMPORTED";
    ImportState["CANCELED"] = "CANCELED";
    ImportState["DELETED"] = "DELETED";
})(ImportState || (ImportState = {}));
//# sourceMappingURL=types.js.map